// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hzef","title":"styles_title__1f4qK"};